import { ComponentStyleConfig } from '@chakra-ui/react';

import { AccessToggleVariants } from '@config/chakra-ui/theme/components/switch/access-toggle/access-toggle';

export const Switch: ComponentStyleConfig = {
    variants: {
        ...AccessToggleVariants
    }
};
